import axiosInstance from "../../../utils/axios";

const path = "web/other/open-registrations"

export const EventList = async (values) => {
    return await axiosInstance().post(`${path}/events/list`, values);
}
export const Details = async (id) => {
    return await axiosInstance().get(`${path}/details?o_id=${id}`);
}